import View from 'ln/view/View';
import { ISequence, IAsset } from './MediaSearchView';
import MediaSearchSlideView from './MediaSearchSlideView';
import List from 'ln/list/List';
import ModifiableList from 'ln/list/ModifiableList';
import { ISlide } from '../../course/slideview/SlideDetailView';
import ListRenderer from 'ln/list/ListRenderer';
import MediaSearchAssetView from './MediaSearchAssetView';
import TagFilterView from './TagFilterView';

class MediaSearchSequenceView extends View {

    private slides:List<ISlide>;
    private slideViews:ListRenderer<ISlide>;

    private assets:ModifiableList<IAsset>;
    private assetViews:ListRenderer<IAsset>;
    private assetFilter:TagFilterView;

    private open:boolean = false;

    public constructor( public data: ISequence ) {
		super( data );
        this.defaultTemplate = 'krw.mediasearch-sequence';

        this.slides = new List<ISlide>( this.data.slides );
        this.assets = new ModifiableList<IAsset>( this.data.files );
    }
    
    init(){
        this.node.js('preview-row').click.add( this.toggleDetails, this );
        
        // slides
        if( this.slides.length > 0 ){
            this.slideViews = new ListRenderer<ISlide>( this.node.js( 'slide-list' ) );
            this.slideViews.defaultRender( function( slide:ISlide ){
                var preview = new MediaSearchSlideView( slide );
                preview.render();
                return { node: preview.node };
            });
            this.slideViews.source = this.slides;
        } else {
            this.node.js( 'slides-container' ).addClass( 'hidden' );
        }

        // assets & asset tagfilter
        if( this.assets.originals.length > 0 ){
            this.assetFilter = new TagFilterView( this.assets, 'krw.courselistmediafilter-tagfilter' );
            this.assetFilter.comparisonAttribute = 'ext';
            this.assetFilter.render();
            this.node.js( 'asset-filter' ).append( this.assetFilter.node );
    
            this.assetViews = new ListRenderer<IAsset>( this.node.js( 'asset-list' ) );
            this.assetViews.defaultRender( function( asset:IAsset ){
                var preview = new MediaSearchAssetView( asset );
                preview.render();
                return { node: preview.node };
            });
            this.assetViews.source = this.assets;
        } else {
            this.node.js( 'medias-container' ).addClass( 'hidden' );
        }

    }

    private toggleDetails(){
        this.open = !this.open;
        this.node.js( 'details-container' ).toggleClass( 'hidden' );
        this.node.one( '.icon' ).toggleClass( 'ssb-icon-font-icon-arrow-down', !this.open );
        this.node.one( '.icon' ).toggleClass( 'ssb-icon-font-icon-arrow-up', this.open );
    }

}

export default MediaSearchSequenceView;